import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Input,
  Form,
  Space,
  Button,
  Drawer,
} from '@lockerpm/design';
import {
} from '@ant-design/icons';

import environmentServices from '../../../../../services/environment';

import { } from '../../../../../utils/common';

import global from '../../../../../config/global';
import storeActions from '../../../../../store/actions';

function FormData(props) {
  const {
    visible = false,
    item = null,
    allItems = [],
    onClose = () => {},
    onReload = () => {},
    callback = () => {}
  } = props
  const { t } = useTranslation()
  const selectedProject = useSelector((state) => state.project.selectedProject)

  const [form] = Form.useForm()
  const [callingAPI, setCallingAPI] = useState(false);

  useEffect(() => {
    if (visible) {
      if (item) {
        form.setFieldsValue({
          name: item.environment.name,
          externalUrl: item.environment.externalUrl,
          description: item.environment.description,
        })
      } else {
        form.setFieldsValue({
          name: '',
          externalUrl: '',
          description: '',
        })
      }
    }
  }, [visible])

  const handleSave = async () => {
    form.validateFields().then(async (value) => {
      const environment = await environmentServices.get_payload(value, selectedProject.id)
      let request = null
      setCallingAPI(true);
      if (item) {
        request = environmentServices.update(selectedProject.id, item.id, environment)
      } else {
        request = environmentServices.create(selectedProject.id, environment)
      }
      await request?.then(async (response) => {
        await onReload();
        handleClose();
        callback(response);
        setCallingAPI(false);
        if (!item) {
          global.store.dispatch(storeActions.updateIsFetchProjects(true));
        }
      }).catch((error) => {
        global.pushError(error)
        setCallingAPI(false);
      })
    })
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={item ? t('environments.edit') : t('environments.new')}
        placement="right"
        onClose={handleClose}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              loading={callingAPI}
              onClick={handleSave}
            >
            { item ? t('button.save') : t('button.create')} 
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'name'}
            className='mb-4'
            label={<div>
              <p className='font-bold'>{t('environment.name')}</p>
              <span>{t('environment.name_desc')}</span>
            </div>}
            rules={[
              global.rules.REQUIRED(t("environment.name")),
              ({ }) => ({
                validator(_, value) {
                  if (value && allItems.filter((i) => i.id != item?.id).map((i) => (i.environment?.name || i.name || '').toLowerCase()).includes(value?.toLowerCase())) {
                    return Promise.reject(new Error(t('validation.existed', { name: t("environment.name") })));
                  }
                  return Promise.resolve();
                },
              })
            ]}
          >
            <Input
              size="medium"
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
          <Form.Item
            name={'externalUrl'}
            label={<div>
              <p className='font-bold'>{t('environment.external_url')}</p>
              <span>{t('environment.external_url_desc')}</span>
            </div>}
          >
            <Input
              size="medium"
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
          <Form.Item
            name={'description'}
            label={<div>
              <p className='font-bold'>{t('common.description')}</p>
            </div>}
          >
            <Input.TextArea
              size="medium"
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormData;
